import React from 'react'


export default function LatestBlogs() {
  return (
    <div className="blog-wrapper pb-5">
  <div className="container-wide pb-lg-5">
    <div className="row">
      <div className="col-lg-8 d-flex">
        <h2 className="text-gray-900 rajdhani-600 h1 mb-0 dark-text">Avatar Lab <br /> blogs every day collection </h2>
      </div>
      <div className="col-lg-4 text-end d-flex flex-column">
        <a href="#" className="rajdhani-600 mt-auto ms-auto mb-3 ls-2 text-gray-900 text-uppercase dark-text font-xs"><u>view all</u></a>
      </div>
    </div>
    <div className="row mt-lg-5 mt-3 pt-lg-3">
      <div className="col-lg-5">
        <article className="post-article w-100 d-flex flex-column mt-3">
          <figure className="w-100"><a href="single-blog-1.html"><img src="images/blog-14.jpg" alt="blog-post" className="img-fluid rounded-6 ovh" /></a></figure>
          <div className="post-tag d-flex flex-row gap-3">
            <span className="bg-teal rounded-pill px-3 rajdhani-600 text-gray-900 ls-1 font-xs">Technology</span>
            <span className="rajdhani-600 text-gray-700 dark-text font-xs">23 September 2023</span>
          </div>
          <h2 className="post-title lh-26 mt-2"><a href="single-blog-1.html" className="rajdhani-600 text-gray-900 dark-text h5 lh-28">We are inspried to reach even to awesome greater hieght 425 million through 2022</a></h2>
          <p className="lh-24 font-sm text-gray-600 rajdhani-500 dark-text">As the world gears up to celebrate International Women's Day 2023, Manchester City Football Club is set to mark the occasion.</p>
        </article>
      </div>
      <div className="col-lg-7">
        <div className="row">
          <div className="col-md-6">
            <div className="mt-3">
              <div className="row">
                <div className="col-4 col-md-4 pe-0"><figure className="w-100 mb-0"><a href="single-blog-1.html"><img src="images/blog-2.jpg" alt="blog-post" className="img-fluid rounded-6 ovh" /></a></figure></div>
                <div className="col-8 col-md-8 d-flex flex-column">
                  <div className><span className="bg-teal rounded-pill px-3 rajdhani-600 text-gray-900 ls-1 font-xs py-1">Technology</span></div>
                  <h2 className="post-title lh-16 mt-1 mb-1"><a href="single-blog-1.html" className="rajdhani-600 text-gray-900 dark-text h6 ls-1 lh-22">We are inspried to reach even to awesome greater hieght</a></h2>    								
                  <span className="rajdhani-600 text-gray-600 font-xs">23 September 2023</span>
                </div>
              </div>
            </div>
            <div className="mt-3">
              <div className="row">
                <div className="col-4 col-md-4 pe-0"><figure className="w-100 mb-0"><a href="single-blog-1.html"><img src="images/blog-4.jpg" alt="blog-post" className="img-fluid rounded-6 ovh" /></a></figure></div>
                <div className="col-8 col-md-8 d-flex flex-column">
                  <div className><span className="bg-teal rounded-pill px-3 rajdhani-600 text-gray-900 ls-1 font-xs py-1">Technology</span></div>
                  <h2 className="post-title lh-16 mt-1 mb-1"><a href="single-blog-1.html" className="rajdhani-600 text-gray-900 dark-text h6 ls-1 lh-22">Purchases Technological Carbon Removals to Advance Sustain</a></h2>    								
                  <span className="rajdhani-600 text-gray-600 font-xs">23 September 2023</span>
                </div>
              </div>
            </div>
            <div className="mt-3">
              <div className="row">
                <div className="col-4 col-md-4 pe-0"><figure className="w-100 mb-0"><a href="single-blog-1.html"><img src="images/blog-3.jpg" alt="blog-post" className="img-fluid rounded-6 ovh" /></a></figure></div>
                <div className="col-8 col-md-8 d-flex flex-column">
                  <div className><span className="bg-teal rounded-pill px-3 rajdhani-600 text-gray-900 ls-1 font-xs py-1">Technology</span></div>
                  <h2 className="post-title lh-16 mt-1 mb-1"><a href="single-blog-1.html" className="rajdhani-600 text-gray-900 dark-text h6 ls-1 lh-22">Becomes the First Virtual Asset Platform to Achieve ISO</a></h2>									
                  <span className="rajdhani-600 text-gray-600 font-xs">23 September 2023</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="mt-3">
              <div className="row">
                <div className="col-4 col-md-4 pe-0"><figure className="w-100 mb-0"><a href="single-blog-1.html"><img src="images/blog-4.jpg" alt="blog-post" className="img-fluid rounded-6 ovh" /></a></figure></div>
                <div className="col-8 col-md-8 d-flex flex-column">
                  <div className><span className="bg-teal rounded-pill px-3 rajdhani-600 text-gray-900 ls-1 font-xs py-1">Technology</span></div>
                  <h2 className="post-title lh-16 mt-1 mb-1"><a href="single-blog-1.html" className="rajdhani-600 text-gray-900 dark-text h6 ls-1 lh-22">Carbon Removals to Advance Sustain extraordinary</a></h2>    								
                  <span className="rajdhani-600 text-gray-600 font-xs">23 September 2023</span>
                </div>
              </div>
            </div>
            <div className="mt-3">
              <div className="row">
                <div className="col-4 col-md-4 pe-0"><figure className="w-100 mb-0"><a href="single-blog-1.html"><img src="images/blog-2.jpg" alt="blog-post" className="img-fluid rounded-6 ovh" /></a></figure></div>
                <div className="col-8 col-md-8 d-flex flex-column">
                  <div className><span className="bg-teal rounded-pill px-3 rajdhani-600 text-gray-900 ls-1 font-xs py-1">Technology</span></div>
                  <h2 className="post-title lh-16 mt-1 mb-1"><a href="single-blog-1.html" className="rajdhani-600 text-gray-900 dark-text h6 ls-1 lh-22">We are inspried to reach even to awesome greater hieght</a></h2>    								
                  <span className="rajdhani-600 text-gray-600 font-xs">23 September 2023</span>
                </div>
              </div>
            </div>
            <div className="mt-3">
              <div className="row">
                <div className="col-4 col-md-4 pe-0"><figure className="w-100 mb-0"><a href="single-blog-1.html"><img src="images/blog-3.jpg" alt="blog-post" className="img-fluid rounded-6 ovh" /></a></figure></div>
                <div className="col-8 col-md-8 d-flex flex-column">
                  <div className><span className="bg-teal rounded-pill px-3 rajdhani-600 text-gray-900 ls-1 font-xs py-1">Technology</span></div>
                  <h2 className="post-title lh-16 mt-1 mb-1"><a href="single-blog-1.html" className="rajdhani-600 text-gray-900 dark-text h6 ls-1 lh-22">Becomes the First Virtual Asset Platform to Achieve ISO</a></h2>									
                  <span className="rajdhani-600 text-gray-600 font-xs">23 September 2023</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

  )
}
